import React from 'react'

import { Field } from 'formik'

import { KeyEventUtil } from 'utils'

import { UsuarioSelect } from 'sharedComponents/select'

import { Form, Col } from '_zari/core'

const UsuarioFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('date-reporteCobranzas-fechaInicio', e)
  }, [])

  const oneRowTrigger = React.useCallback(
    data => {
      setFieldValue('_idUsuario', data._id)
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='USUARIO' htmlFor='select-reporteCobranzas-usuario' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idUsuario'>
          {({ field }) => (
            <UsuarioSelect
              {...field}
              id='select-reporteCobranzas-usuario'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
              oneRowTrigger={oneRowTrigger}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(UsuarioFormGroup)
